import { ButtonProps } from '@material-ui/core'
import { selectors, actions } from 'shared/store'
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'

export const useErrorDialog = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const {
    text,
    title,
    image,
    isOpen = false,
  } = useSelector(selectors.ui.getDialogSettings)

  const refreshPage = () => window.location.reload()

  const cancelAction = () => dispatch(actions.ui.toggleDialog())

  const dialogActions: ButtonProps[] = [
    {
      variant: 'text',
      children: t('cancel'),
      onClick: cancelAction,
    },
    { variant: 'contained', children: t('refreshPage'), onClick: refreshPage },
  ]

  return {
    text: t(text),
    title: t(title),
    image,
    isOpen,
    dialogActions,
    onClose: cancelAction,
  }
}
